"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListSimpleExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/list/examples/simple.ts';
var data = [
    { key: 1, name: 'List item 1' },
    { key: 2, name: 'List item 2' },
    { key: 3, name: 'List item 3' },
    { key: 4, name: 'List item 4' }
];
var ListSimpleExample = /** @class */ (function () {
    function ListSimpleExample() {
        this.interactive = true;
    }
    ListSimpleExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.List, {
                interactive: this.interactive,
                size: this.size
            }, data.map(function (item) { return (0, mithril_1.default)(_1.ListItem, { label: "List item ".concat(item.key) }); }))
        ]);
    };
    ListSimpleExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.interactive,
                label: 'Intearctive',
                onchange: function () { return _this.interactive = !_this.interactive; }
            })
        ];
    };
    return ListSimpleExample;
}());
exports.ListSimpleExample = ListSimpleExample;
